<template>
  <section id="home" class="hero">
    <!-- 图片预加载 - 已改为优化后的WebP格式 -->
    <div v-show="false">
      <img :src="require('@/assets/images/optimized/banner-0.webp')" alt="preload" />
      <img :src="require('@/assets/images/optimized/banner-1.webp')" alt="preload" />
      <img :src="require('@/assets/images/optimized/banner-2.webp')" alt="preload" />
    </div>

    <el-carousel :interval="5000" arrow="always" :height="carouselHeight">
      <!-- 第一张轮播图 -->
      <el-carousel-item>
        <div class="hero-slide slide-1" :class="{ loaded: imagesLoaded[0] }">
          <!-- 加载占位符 -->
          <div v-if="!imagesLoaded[0]" class="image-placeholder">
            <div class="loading-spinner"></div>
          </div>
          <div class="hero-overlay"></div>
          <div class="container">
            <div class="hero-content">
              <h1 class="hero-title animate__animated animate__fadeInUp">{{ $t("hero.slide1.title") }}</h1>
              <p class="hero-subtitle animate__animated animate__fadeInUp animate__delay-1s">{{ $t("hero.slide1.subtitle") }}</p>
              <!-- <el-button type="primary" size="large" class="hero-button animate__animated animate__fadeInUp animate__delay-2s" @click="handleContact"> {{ $t("hero.slide1.button") }} </el-button> -->
            </div>
          </div>
        </div>
      </el-carousel-item>

      <!-- 第二张轮播图 -->
      <el-carousel-item>
        <div class="hero-slide slide-2" :class="{ loaded: imagesLoaded[1] }">
          <div v-if="!imagesLoaded[1]" class="image-placeholder">
            <div class="loading-spinner"></div>
          </div>
          <div class="hero-overlay"></div>
          <div class="container">
            <div class="hero-content">
              <h1 class="hero-title animate__animated animate__fadeInUp">{{ $t("hero.slide2.title") }}</h1>
              <p class="hero-subtitle animate__animated animate__fadeInUp animate__delay-1s">{{ $t("hero.slide2.subtitle") }}</p>
              <!-- <el-button type="primary" size="large" class="hero-button animate__animated animate__fadeInUp animate__delay-2s" @click="handleLearnMore"> {{ $t("hero.slide2.button") }} </el-button> -->
            </div>
          </div>
        </div>
      </el-carousel-item>

      <!-- 第三张轮播图 -->
      <el-carousel-item>
        <div class="hero-slide slide-3" :class="{ loaded: imagesLoaded[2] }">
          <div v-if="!imagesLoaded[2]" class="image-placeholder">
            <div class="loading-spinner"></div>
          </div>
          <div class="hero-overlay"></div>
          <div class="container">
            <div class="hero-content">
              <h1 class="hero-title animate__animated animate__fadeInUp">{{ $t("hero.slide3.title") }}</h1>
              <p class="hero-subtitle animate__animated animate__fadeInUp animate__delay-1s">{{ $t("hero.slide3.subtitle") }}</p>
              <!-- <el-button type="primary" size="large" class="hero-button animate__animated animate__fadeInUp animate__delay-2s" @click="handleInquire"> {{ $t("hero.slide3.button") }} </el-button> -->
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div class="scroll-down animate__animated animate__bounce animate__infinite">
      <i class="el-icon-arrow-down"></i>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
  data() {
    return {
      carouselHeight: "100vh",
      imagesLoaded: [false, false, false],
      // ✅ 已改为优化后的WebP图片 - 测试：第一张改用banner-1
      bannerImages: [require("@/assets/images/optimized/banner-0.webp"), require("@/assets/images/optimized/banner-1.webp"), require("@/assets/images/optimized/banner-2.webp")],
    };
  },
  mounted() {
    this.updateCarouselHeight();
    window.addEventListener("resize", this.updateCarouselHeight);
    this.preloadImages();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateCarouselHeight);
  },
  methods: {
    handleContact() {
      this.$message.success(this.$t("messages.contactSuccess"));
    },
    handleLearnMore() {
      this.$message.success(this.$t("messages.learnMore"));
    },
    handleInquire() {
      this.$message.success(this.$t("messages.inquireNow"));
    },
    updateCarouselHeight() {
      this.carouselHeight = window.innerHeight + "px";
    },
    preloadImages() {
      this.bannerImages.forEach((src, index) => {
        const img = new Image();
        img.onload = () => {
          this.$set(this.imagesLoaded, index, true);
        };
        img.onerror = () => {
          console.error(`Failed to load image: ${src}`);
          this.$set(this.imagesLoaded, index, true);
        };
        img.src = src;
      });
    },
  },
};
</script>

<style scoped>
.hero {
  position: relative;
  width: 100%;
  overflow: hidden;
}

::v-deep .el-carousel {
  width: 100%;
}

::v-deep .el-carousel__container {
  height: 100vh;
}

::v-deep .el-carousel__arrow {
  background-color: rgba(49, 148, 178, 0.6);
  width: 50px;
  height: 50px;
}

::v-deep .el-carousel__arrow:hover {
  background-color: rgba(49, 167, 210, 0.9);
}

::v-deep .el-carousel__indicators {
  bottom: 80px;
}

::v-deep .el-carousel__indicator {
  padding: 8px 4px;
}

::v-deep .el-carousel__button {
  width: 40px;
  height: 4px;
  border-radius: 2px;
  background-color: rgba(255, 255, 255, 0.4);
}

::v-deep .el-carousel__indicator.is-active .el-carousel__button {
  background-color: #fff;
}

.image-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #4e6a7a 0%, #3a7b8d 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.hero-slide {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.5s ease-in;
}

.hero-slide.loaded {
  opacity: 1;
}

/* ✅ 第一张幻灯片 - 移除了导致遮挡的::after伪元素 */
.slide-1 {
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url("@/assets/images/optimized/banner-0.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  will-change: opacity;
}

.slide-1::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: repeating-linear-gradient(90deg, transparent, transparent 2px, rgba(49, 148, 178, 0.03) 2px, rgba(49, 148, 178, 0.03) 4px), repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(49, 148, 178, 0.03) 2px, rgba(49, 148, 178, 0.03) 4px);
  animation: gridMove 20s linear infinite;
  pointer-events: none;
}

/* ✅ 第二张幻灯片 - 已改为优化后的WebP */
.slide-2 {
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url("@/assets/images/optimized/banner-1.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  will-change: opacity;
}

.slide-2::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.05) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
  animation: pulse 4s ease-in-out infinite;
}

/* ✅ 第三张幻灯片 - 已改为优化后的WebP */
.slide-3 {
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url("@/assets/images/optimized/banner-2.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  will-change: opacity;
}

.slide-3::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(ellipse at top, rgba(67, 180, 234, 0.2) 0%, transparent 60%), radial-gradient(ellipse at bottom, rgba(49, 148, 178, 0.2) 0%, transparent 60%);
  animation: fadeInOut 6s ease-in-out infinite;
}

@keyframes gridMove {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

@keyframes fadeInOut {
  0%,
  100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 30% 50%, rgba(49, 167, 210, 0.15) 0%, transparent 50%);
  animation: pulse 4s ease-in-out infinite;
  z-index: 2;
}

.hero-content {
  position: relative;
  z-index: 10;
  text-align: center;
  color: white;
}

.hero-title {
  font-size: 60px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 20px;
  background: white;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 30px;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 40px;
  font-weight: 400;
}

.hero-button {
  padding: 15px 40px;
  font-size: 16px;
  border-radius: 30px;
  background: linear-gradient(135deg, #3194b2, #31a7d2);
  border: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(49, 148, 178, 0.4);
}

.hero-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(49, 167, 210, 0.6);
  background: linear-gradient(135deg, #31a7d2, #43b4ea);
}

.scroll-down {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 24px;
  cursor: pointer;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 36px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  ::v-deep .el-carousel__arrow {
    width: 40px;
    height: 40px;
  }
}
</style>
